import React, { useState, useEffect } from 'react';
import {
    Table,
    Pagination,
    Form,
    Row,
    Col,
    Spinner,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { HiMiniArchiveBoxXMark } from "react-icons/hi2";

const DataTable = ({ columns, data = [], pagination, loading }) => {
    const { t } = useTranslation()
    const [currentPage, setCurrentPage] = useState(pagination?.page);
    const [currentPageSize, setCurrentPageSize] = useState(pagination?.pageSize);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        pagination?.onChange && pagination.onChange({ ...pagination, page: pageNumber });
    };

    const handlePageSizeChange = (e) => {
        setCurrentPageSize(parseInt(e.target.value));
        setCurrentPage(1);
        pagination?.onChange && pagination.onChange({ ...pagination, page: 1, pageSize: parseInt(e.target.value) });
    };

    useEffect(() => {
        setCurrentPage(pagination?.page);
        setCurrentPageSize(pagination?.pageSize);
    }, [pagination])

    if (loading) return <div className="d-flex justify-content-center align-items-center" ><Spinner className="mt-5" variant="primary" /></div>

    return (
        <>
            <div className='w-100 overflow-auto' style={{ minHeight: "200px" }}>
                <Table striped hover className="mt-4">
                    <thead>
                        <tr>
                            {columns.map(e => <th className='text-center'>{e.label}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={item.id + index}>
                                    {columns.map(e => <td className='text-center'>{e?.render ? e?.render(item[e.key], item) : item[e.key]}</td>)}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns?.length} className='py-5'>
                                    <div
                                        className="text-center"
                                        style={{
                                            flexDirection: "column",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "1.5rem",
                                            fontWeight: "500"
                                        }}
                                    >
                                        <HiMiniArchiveBoxXMark style={{ fontSize: "4rem", width: "100%", marginBottom: "0.5rem" }} />
                                        {t("NO_DATA")}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Row className="align-items-center flex-nowrap">
                <Col xs={6} md={6}>
                    <Form.Group controlId="pageSize" className="d-flex align-items-center">
                        <Form.Label className="mb-0 mr-2">{t("ITEMS_PER_PAGE")}</Form.Label>
                        <Form.Control
                            as="select"
                            value={currentPageSize}
                            onChange={handlePageSizeChange}
                            style={{ width: '80px', display: 'inline-block', marginLeft: '10px' }}
                        >
                            {[25, 50, 100, 200].map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Pagination className="justify-content-end">
                        <Pagination.First
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {Array.from({ length: (pagination?.totalPages ?? 0) }, (_, idx) => idx + 1).map(
                            (pageNumber) =>
                                (pageNumber === 1 ||
                                    pageNumber === pagination?.totalPages ||
                                    (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)) && (
                                    <Pagination.Item
                                        key={pageNumber}
                                        active={currentPage === pageNumber}
                                        onClick={() => handlePageChange(pageNumber)}
                                    >
                                        {pageNumber}
                                    </Pagination.Item>
                                )
                        )}
                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === pagination?.totalPages}
                        />
                        <Pagination.Last
                            onClick={() => handlePageChange(pagination?.totalPages)}
                            disabled={currentPage === pagination?.totalPages}
                        />
                    </Pagination>
                </Col>
            </Row>
        </>
    );
};

export default DataTable;
